import React from "react";

export default class NonCompatibleFeaturesDialog extends React.Component {
    /**
     * Dialog for notifying users of non compatile status of D2 features
     * @module NonCompatibleFeaturesDialog
     * @param {Object} props React props
     */
    constructor(props) {
        super(props);
    }

    getNonCompatibleFeatureList(){
        return this.props.nonCompatibleFeatures.map(feature => {
            return <li>{feature}</li>
        })
    }

    /**
     * React render
     * @returns {XML}
     */
    render() {
        
        return (
            <div style={{ fontSize: "1.1em", padding: "20px" }}>
                <p>
                    {this.props.nonCompatibilityHeader}
                </p>
                <ul>
                    {this.getNonCompatibleFeatureList()}
                </ul>
            </div>
        )
    }
}
